export default annotation => window.documentViewer.getAnnotationManager().getAnnotationCopy(annotation);